import { ImageLoaderProps } from "next/image";
import { NextContentfulImageLoaderProps } from "./NextContentfulImage.interfaces";

export function contentfulLoader(config: NextContentfulImageLoaderProps) {
  const { f, fm, fit, h, w } = config || {};

  return ({ src: _src, width, quality }: ImageLoaderProps) => {
    let src = _src;
    if (src.startsWith("//")) {
      src = `https:${src}`;
    }

    const url = new URL(src, process.env.NEXT_PUBLIC_IMAGE_BASE);

    url.searchParams.set("fm", fm || "avif");
    url.searchParams.set("q", (quality || 75).toString());
    url.searchParams.set("w", width.toString());

    if (fit) {
      url.searchParams.set("fit", fit);
    }

    if (f) {
      url.searchParams.set("f", f);
    }

    if (h && w) {
      url.searchParams.set("h", h.toString());
      url.searchParams.set("w", w.toString());
    }

    const netlifyUrl = new URL(
      `${process.env.NEXT_PUBLIC_URL}/.netlify/images`
    );
    netlifyUrl.searchParams.set("url", url.href);

    return netlifyUrl.href;
  };
}
